import React from 'react';
import team from '../images/team.jpg';
import dev from '../images/dev.jpg';
import mechanic from '../images/mechanic.jpg';
import Slider from '../components/Slider';
import '../styles/HomePage.css';

const HomePage = () => {
  return (
    <div className="homepage">
      {/* Slider */}
      <div className="slider-background">
        <Slider />
      </div>

      {/* Sections */}
      <div className="section-container">

        {/* Section 1 */}
        <div className="section">
          <div className="section-text">
            <a href="/who" className="section-link">
              Who We Are
            </a>
            <p>Meet our team and see how we collaborate to bring the best service.</p>
          </div>
          <div className="section-image">
            <img src={team} alt="Team communicating" />
          </div>
        </div>

        {/* Section 2 */}
        <div className="section reverse">
          <div className="section-text">
            <a href="/dev" className="section-link">
              Dev Logs
            </a>
            <p>Check out our latest development updates and progress reports.</p>
          </div>
          <div className="section-image">
            <img src={dev} alt="Update report" />
          </div>
        </div>

        {/* Section 3 */}
        <div className="section">
          <div className="section-text">
            <a href="/careers" className="section-link">
              Careers
            </a>
            <p>Explore opportunities to join our team and grow your career.</p>
          </div>
          <div className="section-image">
            <img src={mechanic} alt="Man at work" />
          </div>
        </div>

      </div>
    </div>
  );
};

export default HomePage;